<template>
	<div class="container" id="FeelingsLog">
		<div class="text-center gold mt-4">
			<h3>
				Healing Log:
				<router-link :to="'/dashboard/' + this.$store.state.profile_active.id" class="">
					<small v-text="this.$store.state.profile_active.user_name"></small>
				</router-link>
			</h3>
		</div>

		<div class="row">
			<div class="offset-md-2 col-md-8">
				<healing-log :userid="parseInt(this.$route.params.user_id)" :limit="200" />
			</div>
		</div>
	</div>
</template>

<script>
import HealingLog from '../components/HealingLog.vue';

export default {
	name: 'Healing',
	components: {
		HealingLog,
	},

	data() {
		return {};
	},

	methods: {},

	mounted() {},

	computed: {},
	watch: {},
};
</script>

<style scoped></style>
